import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { designActions } from '../features/design/designSlice';
import { toast } from 'react-toastify';
import { templateType } from '../../designer/designs/[designId]/DesignDetails/templateCard';
import { selectDesignData } from '../features/design/designSelector';
import { deleteTemplateThunk } from '../features/template/templateThunk';

export const useDeleteTemplate = () => {
    const dispatch = useAppDispatch();
    const designData = useAppSelector(selectDesignData);

    const handleRestore = (type: string, templateId: string, originalTemplate?: any, imageUrl?: string) => {
        if (type === templateType.snapShotImage) {
            dispatch(designActions.restoreTemplate(originalTemplate));
        } else if (type === templateType.photoRealisticImage) {
            dispatch(designActions.restorePhotoRealisticImage({ templateId, imageUrl }));
        } else if (type === templateType.lifeStyleImage) {
            dispatch(designActions.restoreLifestyleImage({ templateId, imageUrl }));
        }
    };

    const deleteTemplate = async ({
        templateId,
        type,
        imageUrl,
    }: {
        templateId: string;
        type: string;
        imageUrl?: string;
    }) => {
        const template = designData.templates.find((t: any) => t.templateId === templateId);
        const backupTemplate = structuredClone(template);
        const photoRealisticBackup = template?.photoRealisticImageUrl;

        dispatch(designActions.deleteTemplateByType({ templateId, type, imageUrlToRemove: imageUrl }));

        try {
            await dispatch(deleteTemplateThunk(templateId)).unwrap();
            toast.success('Deleted successfully');
        } catch (err) {
            handleRestore(type, templateId, backupTemplate, photoRealisticBackup || imageUrl);
            toast.error('Failed to delete. Changes reverted.');
        }
    };

    return { deleteTemplate };
};
